import React from 'react';

/**
 * Spinner Component
 *
 * A simple loading spinner component that displays a spinner animation
 * and a loading message while content is being loaded or processed.
 *
 * @returns {JSX.Element} - The spinner with the loading message
 */

const Spinner = () => (
  <div className="flex flex-col items-center justify-center py-10">
    <div className="relative w-12 h-12">
      <div className="absolute inset-0 rounded-full border-4 border-gray-200" />
      <div className="absolute inset-0 rounded-full border-4 border-dark-blue border-t-transparent animate-spin" />
    </div>
    <p className="mt-3 text-sm text-gray-600">Loading</p>
  </div>
);

export default Spinner;
